// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* eslint-disable css/font-family-fallbacks */
/* Global reset and base typography */

/* Font families */
:root {
  --font-sans:
    system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  --font-jakarta: "Plus Jakarta Sans", var(--font-sans);
  --font-inter: "Inter", var(--font-sans);
}

/* Universal reset */
*,
::before,
::after {
  box-sizing: border-box;
}

/* Base element styles */
html,
body {
  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
  color: white;
  margin: 0;
  font-family: var(--font-inter);
  font-weight: 400;
  line-height: 1.5;
  height: 100vh;
  height: 100dvh;
}

h1,
h2,
h3,
h4 {
  font-family: var(--font-jakarta);
  font-weight: 700;
}

input,
button,
select {
  font-family: inherit;
  font-weight: 400;
}

dt,
dd {
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/base.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C,qCAAqC;;AAErC,kBAAkB;AAClB;EACE;;gEAE8D;EAC9D,qDAAqD;EACrD,uCAAuC;AACzC;;AAEA,oBAAoB;AACpB;;;EAGE,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;;EAEE,6DAA6D;EAC7D,YAAY;EACZ,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;;AAEA;;;;EAIE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;;;EAGE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;AACX","sourcesContent":["/* eslint-disable css/font-family-fallbacks */\n/* Global reset and base typography */\n\n/* Font families */\n:root {\n  --font-sans:\n    system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen,\n    Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  --font-jakarta: \"Plus Jakarta Sans\", var(--font-sans);\n  --font-inter: \"Inter\", var(--font-sans);\n}\n\n/* Universal reset */\n*,\n::before,\n::after {\n  box-sizing: border-box;\n}\n\n/* Base element styles */\nhtml,\nbody {\n  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);\n  color: white;\n  margin: 0;\n  font-family: var(--font-inter);\n  font-weight: 400;\n  line-height: 1.5;\n  height: 100vh;\n  height: 100dvh;\n}\n\nh1,\nh2,\nh3,\nh4 {\n  font-family: var(--font-jakarta);\n  font-weight: 700;\n}\n\ninput,\nbutton,\nselect {\n  font-family: inherit;\n  font-weight: 400;\n}\n\ndt,\ndd {\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
